import { fabric } from 'fabric';
import { type IPoint } from 'fabric/fabric-impl';

abstract class DraggableBrush extends fabric.BaseBrush {
  /**
   * Creates and returns the Object being dragged.
   * `moveToCoords` will be called on the Object as the mouse drags it around
   */
  abstract startDragging(point: IPoint): Promise<fabric.Object | null>;

  /**
   * Override if this brush can't be dragged for any reason
   */
  isDraggable() {
    return true;
  }
}

export default DraggableBrush;
